<template>
  <div class="woven-brand">
    <Logo />
    <h1 class="woven-brand__title">
      {{ title.split("|")[0]
      }}<span class="orange-like">{{ title.split("|")[1] }}</span
      >{{ title.split("|")[2] }}
    </h1>
    <p class="woven-brand__description">
      {{ description }}
    </p>
    <slot></slot>
    <div class="navigation" v-if="!noStep">
      <div :class="'navigation__nav' + (step() === 1 ? ' active' : '')">
        <div>1</div>
        <div>BANK DETAILS</div>
      </div>
      <div
        :class="
          'navigation__nav' + (step() === 2 || step() === 3 ? ' active' : '')
        "
      >
        <div>2</div>
        <div>BUSINSESS PROFILE</div>
      </div>
      <div style="margin-left: 20px" v-if="step() === 2 || step() === 3">
        <p class="navigation__sub-nav" :class="step() === 2 ? 'active' : ''">
          About your business
        </p>
        <p class="navigation__sub-nav" :class="step() === 3 ? 'active' : ''">
          Contact Information
        </p>
      </div>
      <div
        :class="'navigation__nav' + (step() >= 4 ? ' active' : '')"
        style="margin-bottom: 5px"
      >
        <div>3</div>
        <div>KYC DETAILS</div>
      </div>
      <div style="margin-left: 20px; padding: 10px">
        <div
          :class="
            'navigation__sub-nav' + (step() >= 4 && step() < 6 ? ' active' : '')
          "
        >
          Upload Documents
        </div>
        <div
          v-if="!showBusinessOwner"
          :class="'navigation__sub-nav' + (step() === 6 ? ' active' : '')"
        >
          Director Details
        </div>
        <div
          v-if="showBusinessOwner"
          :class="'navigation__sub-nav' + (step() === 6 ? ' active' : '')"
        >
          Business Owner
        </div>
      </div>
    </div>
    <BackgroundImage />
  </div>
</template>
<script>
import Logo from "@/components/logo";
import BackgroundImage from "@/components/backgroundlogo";
export default {
  name: "WovenBrand",
  components: {
    Logo,
    BackgroundImage
  },
  props: {
    title: String,
    description: String,
    noStep: {
      type: Boolean,
      defaultValue: false,
    },
    showBusinessOwner: Boolean,
  },
  date() {
    return {
      state: { step: 1 },
    };
  },
  methods: {
    step() {
      return this.$store.getters.getOnboardStep;
    },
    handleRedirection() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.woven-brand {
  background: #fafafa;
  overflow: hidden;
  .orange-like {
    color: #e00b5b;
  }
  .navigation {
    .navigation__nav {
      color: rgba(97, 110, 124, 0.3) !important;
      &.active {
        color: #f36b7f !important;
        > div:nth-child(1) {
          border: 1.5px solid #f36b7f;
          color: #f36b7f;
        }
      }
    }
    &__sub-nav {
      margin-top: -10px;
      padding: 10px;
      color: rgba(59, 67, 75, 0.3);
      &.active {
        color: #3b434b !important;
      }
    }
    &__nav {
      display: flex;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 20px;
      color: #616e7cb3;
      align-items: center;
      margin: 20px 0;
      > div:nth-child(1) {
        box-sizing: border-box;
        border: 1.5px solid rgba(97, 110, 124, 0.6);
        border-radius: 50%;
        padding: 4px 7px;
        margin-right: 15px;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
      }
      > div:nth-child(2) {
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 20px;
      }
    }
  }
  &__logo {
    padding-bottom: 106px;
    cursor: pointer;
  }
  &__title {
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 41px;
    color: #2d3044;
    width: 265px;
  }
  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: #616e7c;
    width: 266px;
  }
}
</style>